"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkMap = void 0;
function mkMap(values, keyOf, valueOf = (_, self) => self) {
    return values.reduce((all, next) => {
        const key = keyOf(next);
        return all.set(key, valueOf(key, next));
    }, new Map());
}
exports.mkMap = mkMap;
